import { Link } from "@tanstack/react-router";
import React from "react";
import { useTranslation } from "react-i18next";

import backgroundImage from "./background.jpg";

export const HomePage: React.FC = () => {
  const { t } = useTranslation();

  return (
    <div className="">
      <div className="flex flex-col items-stretch justify-center gap-6 p-6 md:flex-row md:p-12">
        <div className="bg-base-200 rounded-box flex w-full items-center justify-center md:w-2/3">
          <div className="dui-placeholder flex items-center justify-center rounded-full">
            <img src={backgroundImage} width="100%" alt={t("home.image")} />
          </div>
        </div>

        <div className="flex w-full flex-col md:w-1/3">
          <div>
            <h1 className="mb-2 text-3xl font-bold">{t("home.title")}</h1>
            <p className="mb-6">{t("home.subtitle")}</p>
          </div>

          <div className="mt-6 grid w-full grid-cols-1 gap-4">
            <Link to="/books" search={{ owned: true }} className="dui-btn dui-btn-primary dui-w-full">
              {t("home.links.mybooks")}
            </Link>
            <Link to="/books" search={{ read: "reading" }} className="dui-btn dui-btn-outline dui-w-full">
              {t("home.links.currentlyreading")}
            </Link>
            <Link to="/books" search={{ owned: true, tbr: true }} className="dui-btn dui-btn-outline dui-w-full">
              {t("home.links.readinglist")}
            </Link>
            <Link to="/books" search={{ owned: false, tbr: true }} className="dui-btn dui-btn-outline dui-w-full">
              {t("home.links.wanted")}
            </Link>
          </div>
        </div>
      </div>
    </div>
  );
};
